/* Gemeinsame Darstellung von E-Mail-/Ticket-Beschreibungen.
   Hybrid-Logik: Standard ist das Dark-Theme. Bringt die Mail eigene
   Text-/Hintergrundfarben mit (sonst schwarz-auf-dunkel = unlesbar),
   wird sie auf einem hellen "Briefbogen" gerendert wie in einem Mail-Client. */

.content {
  font-size: 0.9375rem;
  line-height: 1.6;
  word-break: break-word;
  overflow-wrap: anywhere;
}

/* Auf kleinen Screens (Mobil) größere Schrift für bessere Lesbarkeit */
@media (max-width: 48em) {
  .content {
    font-size: 1rem;
    line-height: 1.65;
  }
}

/* Plain-Text (keine HTML-Tags) — Zeilenumbrüche erhalten */
.plain {
  white-space: pre-wrap;
}

/* Outlook/Word packen jede Signaturzeile in ein eigenes <p> mit vollem
   Absatzabstand — die Beschreibung wird dadurch doppelt so lang wie nötig.
   Absätze kompakt halten (wie Weclapp es rendert); inline margin-bottom der
   Mail gewinnt dank :where()=0-Spezifität weiterhin. */
.content :where(p) {
  margin: 0 0 0.35em;
}

/* Leer-Absätze (<p>&nbsp;</p>) nicht zusätzlich zur eigenen Höhe Abstand geben */
.content :where(p:empty) {
  margin: 0;
}

/* Bilder nie über den Container hinaus */
.content :where(img) {
  max-width: 100%;
  height: auto;
}

/* Tabellen aus Mail-Layouts nicht horizontal sprengen */
.content :where(table) {
  max-width: 100%;
}

/* Verhindert, dass schmale td-Attribute (z.B. width="1") jeden Buchstaben
   in eine eigene Zeile zwingen (typisch bei E-Mail-Signaturen) */
.content :where(td),
.content :where(th) {
  min-width: 2ch;
  word-break: break-word;
  overflow-wrap: anywhere;
}

/* --- Mail bringt KEINE eigenen Farben → Theme-Textfarbe übernehmen --- */
.dark {
  color: inherit;
}

/* Links auf dunklem Grund lesbar halten (Browser-Default wäre dunkelblau) */
.dark :where(a) {
  color: var(--mantine-color-cyberOrange-4, #ff8a3d);
}

/* --- Heller Briefbogen: Mail bringt eigene Farben/Hintergründe mit --- */
.light {
  background: #ffffff;
  color: #1a1a1a;
  padding: 16px;
  border-radius: 8px;
  /* eigene Farben der Mail (inline styles) gewinnen dank :where()=0-Spezifität */
}

/* --- Ticket-Beschreibung im ITIL-Format (lib/ticketDescriptionLayout.ts) ---
   Label-Spalte links, Inhalt rechts; auf dem Handy Label über dem Inhalt. */
.itil {
  display: flex;
  flex-direction: column;
  gap: 0.6em;
}

.row {
  display: grid;
  grid-template-columns: minmax(8.5rem, max-content) 1fr;
  column-gap: 1rem;
  align-items: baseline;
}

.label {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--mantine-color-dimmed);
  /* Grundlinie des Labels auf die erste Textzeile setzen */
  line-height: 1.6rem;
}

.body :where(p) {
  margin: 0 0 0.25em;
}

.body :where(p:last-child),
.body :where(ul:last-child),
.body :where(ol:last-child) {
  margin-bottom: 0;
}

.body :where(ul, ol) {
  margin: 0.15em 0 0.25em;
  padding-left: 1.2em;
}

@media (max-width: 48em) {
  .row {
    grid-template-columns: 1fr;
    row-gap: 0.1em;
  }
}

/* Hinweise der Portal-Automatik (✏️ bearbeitet, 📥 übernommen, 🤖 KIAN) — gehören
   nicht zum Anliegen, deshalb abgesetzt, klein und gedämpft. */
.notes {
  margin-top: 0.9em;
  padding-top: 0.6em;
  border-top: 1px solid var(--mantine-color-default-border);
}

.note {
  margin: 0 0 0.2em;
  font-size: 0.8125rem;
  line-height: 1.5;
  font-style: italic;
  color: var(--mantine-color-dimmed);
}

.note:last-child {
  margin-bottom: 0;
}
